import React from "react";
import { Box, Skeleton, useTheme } from "@kaltura/mediaspace-shared-styled";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";

const StyledMediaGrid = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: theme.spacing(4),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        gap: theme.spacing(2),
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "block",
    },
}));

const StyledResultsItemSkeleton = styled(Skeleton)(({ theme }) => ({
    height: 0,
    paddingTop: "70%",
    borderRadius: theme.kaltura.shape.roundness2,
}));

const StyledResultsItemSkeletonContainer = styled("div")(({ theme }) => ({
    position: "relative",
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        marginBottom: theme.spacing(2),
    },
}));

export const MediaGridSkeleton = () => {
    const theme = useTheme();
    const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

    const gridItems = isDownMd ? 3 : 6;
    return (
        <div>
            <StyledMediaGrid>
                {[...Array(gridItems)].map((_, index) => (
                    <StyledResultsItemSkeletonContainer key={index}>
                        <StyledResultsItemSkeleton variant="rectangular" />
                    </StyledResultsItemSkeletonContainer>
                ))}
            </StyledMediaGrid>
        </div>
    );
};
